import StackedAreaChart from './StackedAreaChart';

export default StackedAreaChart;
export { StackedAreaChart };
